// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"b127808e","207":"bdfd9084","488":"c3daa4c1","531":"0a174879","967":"23bd2b6d"}[chunkId] + ".chunk.js";
};